<script>
import { Bar } from 'vue-chartjs'
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels'
import merge from 'lodash/merge'

export default {
  extends: Bar,
  props: {
    labels: {
      type: Array,
      default: () => [],
    },
    datasets: {
      type: Array,
      default: () => [],
    },
    yLabel: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default: () => {},
    },
    options: {
      type: Object,
      default: () => {},
    },
    barLabel: {
      type: Boolean,
      default: false,
    },
    labelColor: {
      type: String,
      default: 'Black',
    },
  },
  computed: {
    computedData() {
      return {
        labels: this.labels,
        datasets: this.datasets,
        ...this.data,
      }
    },
    computedOptions() {
      let defaultOptions = {
        plugins: {
          datalabels: {
            color: this.labelColor,
            display: true,
            font: {
              weight: 'bold',
            },
            formatter: (value) => value,
          },
        },
        layout: {
          padding: {
            right: 48,
            top: 48,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              gridLines: {
                color: 'rgba(166, 176, 207, 0.1)',
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                color: 'rgba(166, 176, 207, 0.1)',
              },
              scaleLabel: {
                display: true,
                labelString: this.yLabel,
              },
            },
          ],
        },
      }

      return merge(defaultOptions, this.options)
    },
  },
  mounted() {
    if (this.barLabel) {
      this.addPlugin(ChartJSPluginDatalabels)
    }
    this.renderChart(this.computedData, this.computedOptions)
  },
}
</script>
